export default {
  apiUrl: "/api",
  authUrl: "/auth/office365",
  socketUrl: "",
  signoutURL: "https://login.windows.net/common/oauth2/logout?post_logout_redirect_uri=http://eye.1screen.com",
  zendeskURL: "https://attachment.zendesk.com/",
  entity: '1screen',
  zendeskFields: {
    msisdn: 26961612,
    currency: 28274265,
    amount: 28125889,
    method: 28274745,
    name: 360000200209,
    lastName: 360000145709
  }
}



// WEBPACK FOOTER //
// ./src/config/config-live.js